import * as actions from '../actions/session'
import { urls } from '../constants/salesforce'
import { appTypes, LOCAL_TOKEN, themeTypes} from '../constants/session'
import { getUserLocalThemePreference } from '../utils/session'

const { NODE_ENV, REACT_APP_ACCESS_TOKEN = 'LOCAL_AUTH', REACT_APP_OPPORTUNITY_ID, REACT_APP_OPPORTUNITY_NUMBER } = process.env
const isProduction = NODE_ENV === 'production'
// Use locally stored token or fallback on config token
const devAuthToken = localStorage.getItem(LOCAL_TOKEN) || REACT_APP_ACCESS_TOKEN
const devOpportunityId = REACT_APP_OPPORTUNITY_ID
const devOpportunityNumber = REACT_APP_OPPORTUNITY_NUMBER

export const initialState = {
  appType: appTypes.EC,
  sessionId: undefined,
  enabledFeatures: undefined,
  accessToken: isProduction ? undefined : devAuthToken,
  opportunityId: isProduction ? undefined : devOpportunityId,
  opportunityNumber: isProduction ? undefined : devOpportunityNumber,
  guid: undefined,
  isAuthorized: isProduction ? undefined : true,
  workflowStepId: undefined,
  initialWorkflowStepId: undefined,
  buyflowType: undefined,
  salesforce: {
    origin: undefined,
    paths: {},
    urls: {
      ...urls,
      opportunity: undefined,
      officeCameras: '/'
    }
  },
  bundleBuilder: {
    reasons: undefined
  },
  themeType: getUserLocalThemePreference(),
  auth: {
    sourceSystem: undefined,
    handshakeGuid: undefined,
    handshakeToken: undefined,
    parentOrigin: undefined
  }
}

function sessionReducer(state = initialState, { type, payload } = {}) {
  switch (type) {
    case actions.SET_SESSION_ID: {
      const { sessionId } = payload

      return { ...state, sessionId }
    }

    case actions.SET_SESSION_DATA: {
      return { ...state, ...payload }
    }

    case actions.HIDE_BUNDLE_BUILDER_MODAL: {
      return {
        ...state,
        bundleBuilder: {
          ...state.bundleBuilder,
          showModal: false
        }
      }
    }

    case actions.JOIN_SALESFORCE_SESSION_URLS: {
      const { opportunityId } = payload
      const { urls: salesforceUrls } = state.salesforce

      return {
        ...state,
        salesforce: {
          ...state.salesforce,
          urls: {
            ...state.salesforce.urls,
            opportunity: `${salesforceUrls.opportunity}${opportunityId}`
          }
        }
      }
    }

    case actions.GET_CURRENT_WORKFLOW_STEP: {
      return { ...state, workflowStepId: 0 }
    }

    case actions.TOGGLE_THEME: {
      return {
        ...state,
        themeType:
          state.themeType === themeTypes.regTheme
            ? themeTypes.darkTheme
            : themeTypes.regTheme
      }
    }
    case actions.SET_BUYFLOW_TYPE:
      return {
        ...state,
        buyflowType: payload
      }

    case actions.SET_CBM_BUTTON_SCROLL_TRIGGERED: {
      return {
        ...state,
        isCbmButtonScrollTriggered: payload
      }
    }

    default: {
      return state
    }
  }
}

export default sessionReducer
